module.exports = __webpack_public_path__ + "img/redwulf-100A.b049eb50.png";